import { forwardRef } from "react";
import { cn } from "../../lib/cn";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Toggles the invalid outline + aria-invalid on the field. */
  invalid?: boolean;
}

/** Form input — semantic tokens on surface + border, focus ring on the
 *  accent, destructive outline when `invalid`. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "h-10 w-full rounded-lg px-3 text-sm",
        "bg-surface-tertiary text-text-primary placeholder:text-text-muted",
        "border border-border-light",
        "transition-colors",
        "hover:border-border-medium",
        "focus:border-accent-primary focus:outline-none focus:ring-2 focus:ring-accent-primary/25",
        invalid && "border-destructive focus:ring-destructive/25",
        "disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
      {...rest}
    />
  );
});
